import { observer } from 'mobx-react-lite'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'
import { PaymentCommon } from 'pages/settings/ui/PaymentCommon/PaymentCommon'

export const Payment = observer(() => {
  const {
    addTollFreeNumberStore: {
      paymentStore,
      chooseNumberTabsStore,
      tollFreeStepsStore,
      confirmNumber,
    },
  } = useTollFreeStepsContext()

  return (
    <PaymentCommon
      paymentStore={paymentStore}
      stepLoading={tollFreeStepsStore.stepLoading}
      formattedNumber={chooseNumberTabsStore.selectedNumber?.formatted || ''}
      confirmNumber={confirmNumber}
    />
  )
})
